import React, { Component, FormEvent, MouseEvent, ReactNode } from 'react';
import { ColumnBodyOptions, ColumnProps } from 'primereact/column';
import CustomTable from '../../custom/CustomTable';
import { CollectionListField, ListColumnField } from '../../../domain/list/ListDomains';
import CustomInput from '../../custom/CustomInput';
import CustomEmptyComponent from '../../custom/CustomEmptyComponent';
import { dispatch, RootState } from '../../../redux/store';
import { ListState } from '../../../redux/reducers/ListReducer';
import { changeList, changeListCreatedData, changeListData, changeListIsUpdate } from '../../../redux/actions/ListActions';
import { connect } from 'react-redux';
import { ConnectedProps } from 'react-redux/es/exports';
import MessageUtil from '../../../util/MessageUtil';
import ListDataService from '../../../service/ListDataService';
import ServiceContainer from '../../../config/ServiceContainer';
import { ServiceNames } from '../../../constant/ServiceNames';
import { apiUrl, InstanceContainer } from '../../../config/binding/InstanceBinding';
import Injectables from '../../../constant/Injectables';
import { query, repository, subscribe } from '@trlogic/client-js';
import CustomPaginator, { CustomPaginatorProps } from '../../custom/CustomPaginator';
import _ from 'lodash';
import DataType from '../../../constant/DataType';
import ItemToolsMenu from '../../ItemToolsMenu';
import { Dialog } from 'primereact/dialog';
import { customConfirm } from '../../custom/CustomPopupConfirm';
import Icon from '../../../icons/Icon';
import RoleHelper from '../../../RoleHelper';
import CustomCheckBox from '../../custom/CustomCheckBox';
import { ComponentState, setSelectedItems } from '../../../redux/actions/ComponentActions';
import { Calendar, CalendarChangeParams } from 'primereact/calendar';
import $ from 'jquery';
import FilterUtil from '../../../util/FilterUtil';
import { ListDataExportJob } from '../../../domain/job/JobDomain';
import JobService from '../../../service/JobService';
import FileUploader, { UploadProgress } from '../../sandbox/FileUploader';
import EnvironmentUtil from '../../../util/EnvironmentUtil';
import { AnimatedButton } from '@trlogic/ui-pack';
import HttpClient from '../../../gateway/HttpClient';
import GatewayContainer from '../../../config/GatewayContainer';
import GatewayNames from '../../../constant/GatewayNames';
import HttpMethod from '../../../constant/HttpMethod';
import { Tooltip } from 'primereact/tooltip';
import ComponentName from '../../../constant/ComponentName';
import CustomLoading from '../../custom/CustomLoading';
import LanguageUtil from '../../../util/LanguageUtil';
import PendingCheckerRequestTracker from '../../../helpers/PendingCheckerRequestTracker';
import ReadOnlyQueryableRepository = repository.ReadOnlyQueryableRepository;
import Filter = query.Filter;
import empty = query.empty;
import QueryBuilder = query.QueryBuilder;
import { ListHistoryMeta } from '../../../helpers/ListHistoryPreviewHelper';

class ListDataViewComponent extends Component<Props, State> {
  public state: State = new State();

  private listDataService: ListDataService = ServiceContainer.getInstance().get(ServiceNames.LIST_DATA);
  private jobService: JobService = ServiceContainer.getInstance().get(ServiceNames.JOB);
  private repository: ReadOnlyQueryableRepository = InstanceContainer.get(Injectables.REPOSITORY);
  private httpClient: HttpClient = GatewayContainer.getInstance().get(GatewayNames.API_CLIENT);
  private readonly environmentUtil: EnvironmentUtil = InstanceContainer.get(Injectables.ENVIRONMENT_UTIL);

  private collectionDataSubscription: subscribe.Subscription | undefined;
  private computation: subscribe.Computation | undefined;
  private pendingDeleteTracker = new PendingCheckerRequestTracker();

  public render(): ReactNode {
    const { currentPage, rows, fileVisible, loading, file, percent, progress, pendingDelete } = this.state;
    const {
      list: { data: liveData, list },
      component: { selectedComponentIds },
      historyMode,
      historyMeta,
    } = this.props;
    if (loading) {
      return <CustomLoading />;
    }
    const data = historyMode ? liveData.slice((currentPage - 1) * rows, currentPage * rows) : liveData;
    const totalRecord = historyMode ? liveData.length : this.state.totalRecord;
    return (
      <div className={'flex w-full h-full flex-col px-5'}>
        <div className={'flex flex-col w-full h-full lg:!max-h-[calc(100vh-22.25rem)] overflow-y-hidden'}>
          {historyMode && (
            <div className={'flex flex-col gap-y-1 mb-2'} data-testid='list_data_history_banner'>
              {historyMeta?.hasGap && (
                <div className={'text-xs text-amber-600'}>
                  {LanguageUtil.get({
                    id: 'components.list.history.hasGapWarning',
                    defaultMessage:
                      'This list has had CSV import(s) in its history; items added via CSV import may not appear in this historical view.',
                  })}
                </div>
              )}
              {historyMeta?.truncated && (
                <div className={'text-xs text-amber-600'}>
                  {LanguageUtil.get({
                    id: 'components.list.history.truncatedWarning',
                    defaultMessage: 'This list has a large history; this view may be incomplete.',
                  })}
                </div>
              )}
            </div>
          )}
          {!historyMode && (
            <ItemToolsMenu
              createFunc={this.openCreate}
              id={`item-tools-list`}
              component={ComponentName.LIST}
              customCreateName={'Add'}
              exportVisible={true}
              exportVisibleAlways={true}
              exportFunc={this.onExport}
              importVisible={true}
              importFunc={() => this.setState({ fileVisible: true })}
              onChangeFilter={this.onChangeFilter}
              defaultFilterDisabled
              removeAllFunc={pendingDelete ? undefined : this.onRemoveAll}
              itemsIsSelected={selectedComponentIds.length > 0}
            />
          )}
          {list.fields.length == 0 || data.length == 0 ? (
            <div className={'flex w-full h-full items-center justify-center'} data-testid={`${ComponentName.LIST}_empty_list_data`}>
              <CustomEmptyComponent
                label={LanguageUtil.get({
                  id: 'common.label.startYourTransactionsByCreatingNewList',
                  defaultMessage: 'You can start your transactions by creating a new list.',
                })}
              />
            </div>
          ) : (
            <div className={'lg:!max-h-[calc(100vh-27.625rem)] h-full'}>
              <CustomTable
                columns={this.getColumns()}
                selection={selectedComponentIds}
                onSelectionChange={this.onSelectionChange}
                selectionMode='checkbox'
                value={data}
              />
            </div>
          )}
        </div>
        <CustomPaginator
          currentPage={currentPage}
          currentRecords={data.length}
          rows={rows}
          totalRecords={totalRecord}
          rowsPerPageOptions={[5, 10, 20, 50, 100, 200]}
          onPageChange={this.onPageChange}
        />
        <Dialog
          header={'File Upload'}
          className={'min-w-[30vh] min-h-[64vh]'}
          closable={true}
          closeOnEscape={true}
          dismissableMask
          visible={fileVisible}
          onHide={() => this.setState({ fileVisible: false })}
        >
          <div className={'flex flex-col gap-y-2 h-full'}>
            <div className={'flex flex-col gap-y-2 items-center justify-center w-full h-full border-2 border-dashed'}>
              <FileUploader
                acceptedFiles={['text/csv']}
                file={file}
                percent={percent}
                progress={progress}
                onChangeFile={(file) => this.setState({ file })}
                maxBytes={this.environmentUtil.getStorageMaxSize()}
              />
            </div>
            <div className={'flex justify-between'}>
              <AnimatedButton
                icon={'import'}
                text={LanguageUtil.get({ id: 'common.buttons.import', defaultMessage: 'Import' })}
                customType={'not-fraud'}
                onClick={this.uploadFile}
              />
            </div>
          </div>
        </Dialog>
      </div>
    );
  }

  public componentDidMount(): void {
    if (this.props.historyMode) {
      this.setState({ loading: false });
    } else {
      this.startTracker();
      const {
        list: { list },
      } = this.props;
      this.pendingDeleteTracker.start(ComponentName.LIST_DATA, list.name, (pendingDelete) => this.setState({ pendingDelete }));
    }
    dispatch(setSelectedItems([]));
  }

  public async componentWillUnmount() {
    await this.stopTracker();
    await this.pendingDeleteTracker.stop();
  }

  private startTracker = () => {
    const {
      list: { list },
    } = this.props;
    const { filter, rows, currentPage } = this.state;
    if (!list.name) return;
    let dataCollection: string = `list_${list.name}`;
    let dataQuery: query.SelectQuery = query.QueryBuilder.select()
      .limit(rows)
      .skip((currentPage - 1) * rows)
      .from(dataCollection)
      .where(filter)
      .orderBy({
        field: 'createdAt',
        operator: 'DESC',
      })
      .build();
    this.collectionDataSubscription = subscribe.Formica.subscribe(dataCollection, dataQuery);
    this.computation = subscribe.Tracker.autorun(this.tracker, [this.collectionDataSubscription]);
  };

  private tracker = async () => {
    const { changeListData } = this.props;
    const { filter, rows } = this.state;
    if (this.collectionDataSubscription?.ready()) {
      const {
        list: { list },
      } = this.props;
      const dataCollection: string = `list_${list.name}`;
      const dataQuery: query.SelectQuery = QueryBuilder.select()
        .from(dataCollection)
        .limit(rows)
        .orderBy({
          field: 'createdAt',
          operator: 'DESC',
        })
        .where(filter)
        .build();
      const data = await this.repository.findMany<CollectionListField>(dataQuery);
      await this.prepareCount();
      changeListData(data);
      this.prepareFilterFields();
      this.setState({ loading: false });
    }
  };

  private stopTracker = async () => {
    await this.collectionDataSubscription?.stop();
    await this.computation?.stop();
  };

  private resubscribeTracker = async () => {
    this.setState({ loading: true });
    if (this.computation == undefined) {
      this.startTracker();
    } else {
      this.computation?.onStop(this.startTracker);
      await this.stopTracker();
    }
  };

  private onSelectionChange = (e: any) => {
    dispatch(setSelectedItems(e.value));
  };

  private openCreate = async () => {
    const {
      list: { data, list },
      changeListData,
      changeListCreatedData,
    } = this.props;
    const _data = _.cloneDeep(data);
    if (!RoleHelper.canEdit('List')) return;
    if (list.fields.length > 0) {
      let listData: Record<string, string | number | boolean | null> = {};
      list.fields.forEach((col) => {
        if (col.name == 'createdAt' || col.name == 'lastUpdated') {
          listData[col.name] = new Date().valueOf();
        }

        if (col.name == 'expireAt') {
          listData[col.name] = null;
        }
        switch (col.type) {
          case DataType.STRING:
            listData[col.name] = '';
            break;
          case DataType.NUMBER:
            listData[col.name] = 0;
            break;
          case DataType.BOOLEAN:
            listData[col.name] = false;
            break;
        }
      });
      _data.unshift(listData);
      changeListCreatedData(listData);
      changeListData(_data);
    }
  };

  private getColumns = (): ColumnProps[] => {
    const {
      list: { list },
    } = this.props;
    const { currentPage, rows } = this.state;
    const tableColumns: Array<any> = new Array<any>();
    list.fields.map((column) => {
      tableColumns.push({
        key: column.name,
        field: column.name,
        alignHeader: 'left',
        header: column.name,
        body: (record: Record<string, any>, options: ColumnBodyOptions) => {
          const rowIndex = options.rowIndex + (currentPage - 1) * rows;
          return this.getValueComponent(column, record, rowIndex);
        },
      });
    });
    if (this.props.historyMode) {
      return tableColumns;
    }
    tableColumns.push({
      field: 'action',
      header: 'Action',
      className: 'max-w-[60px] 2xl:max-w-[100px]',
      sortable: false,
      body: (record: Record<string, any>) => {
        const { pendingDelete } = this.state;
        return (
          <div
            className={'flex items-center justify-center'}
            onClick={(e: MouseEvent<HTMLElement>) => {
              if (pendingDelete) return;
              RoleHelper.canEdit('List') &&
                customConfirm({
                  target: e.currentTarget,
                  accept: () => {
                    this.removeCacheData(record);
                  },
                  message: LanguageUtil.get({ id: 'messages.confirm.deleteRow', defaultMessage: 'Are you sure you want to delete the row?' }),
                });
            }}
          >
            <Tooltip position={'left'} target={'.remove'}>
              {LanguageUtil.get({
                id: pendingDelete ? 'messages.info.pendingDeleteApproval' : 'common.label.remove',
                defaultMessage: pendingDelete ? 'A delete request is already waiting for approval' : 'Remove',
              })}
            </Tooltip>
            <Icon
              icon={'delete'}
              size={20}
              color={'primary'}
              className={`remove flex items-center justify-center ${
                pendingDelete ? 'text-[#C0C7D1] cursor-not-allowed' : 'hover:text-primary text-[#607080] hover:cursor-pointer'
              }`}
            />
          </div>
        );
      },
    });
    return tableColumns;
  };

  private getValueComponent = (column: ListColumnField, record: Record<string, any>, rowIndex: number) => {
    const isKeyEmpty = column.key && (record[column.name] == undefined || (typeof record[column.name] == 'string' && record[column.name]?.trim().length == 0));
    switch (column.type) {
      case DataType.NUMBER:
        return (
          <div className={'px-5'}>
            <CustomInput
              label={'input'}
              data-testid={`${ComponentName.LIST}_input_${column.name}_${rowIndex}`}
              type='number'
              id={record[column.name]}
              inputType={!isKeyEmpty ? 'ghost' : 'default'}
              className={isKeyEmpty ? 'border-2 border-red-400' : ''}
              value={record[column.name]}
              disabled={(record.id != undefined && column.key) || !RoleHelper.canEdit('List') || this.props.historyMode}
              onChange={(e) => this.onChangeData(e, record, column as ListColumnField)}
              onBlur={(e) => this.onBlurData(record, column as ListColumnField)}
            />
          </div>
        );
      case DataType.STRING:
        return (
          <div>
            <CustomInput
              label={'input'}
              type='text'
              inputType={!isKeyEmpty ? 'ghost' : 'default'}
              data-testid={`${ComponentName.LIST}_input_${column.name}_${rowIndex}`}
              className={isKeyEmpty ? 'border-2 border-red-400' : ''}
              value={record[column.name]}
              id={record[column.name]}
              disabled={(record.id != undefined && column.key) || !RoleHelper.canEdit('List') || this.props.historyMode || column.name == 'createdAt' || column.name == 'lastUpdated'}
              onChange={(e) => this.onChangeData(e, record, column as ListColumnField)}
              onBlur={(e) => this.onBlurData(record, column as ListColumnField)}
            />
          </div>
        );
      case DataType.DATE:
        return (
          <Calendar
            showTime
            className={'!max-h-[32px]'}
            data-testid={`${ComponentName.LIST}_input_${column.name}_${rowIndex}`}
            value={record[column.name] == undefined ? undefined : new Date(record[column.name])}
            id={record[column.name]}
            disabled={(record.id != undefined && column.key) || !RoleHelper.canEdit('List') || this.props.historyMode || column.name == 'createdAt' || column.name == 'lastUpdated'}
            onChange={(e) => this.onChangeDateData(e, record, column as ListColumnField)}
            onHide={() => this.onBlurData(record, column)}
            hourFormat='24'
          />
        );
      case DataType.BOOLEAN:
        return (
          <div className='text-left'>
            <CustomCheckBox
              checked={record[column.name]}
              onChangeChecked={(checked, e) => {
                e.stopPropagation();
                e.preventDefault();
                this.onChangeBooleanData(checked, record, column as ListColumnField);
              }}
              data-testid={`${ComponentName.LIST}_input_${column.name}_${rowIndex}`}
            />
          </div>
        );
      default:
        return null;
    }
  };

  private back = () => {
    this.setState({ fileVisible: false });
  };

  private onChangeData = async (e: FormEvent<HTMLInputElement>, record: any, column: ListColumnField) => {
    if (this.props.historyMode) return;
    const {
      list: { data, newData },
      changeListData,
      changeListCreatedData,
    } = this.props;
    if (record && record.id != undefined && column.key) return;
    if (record != undefined) {
      const value = e.currentTarget.value;
      switch (column.type) {
        case DataType.NUMBER:
          try {
            if (value.length == 0) {
              record[column.name] = null;
              break;
            }
            const nmb = Number(value);
            if (!isNaN(nmb)) {
              record[column.name] = nmb;
            } else {
              record[column.name] = null;
            }
          } catch (e) {}
          break;
        default:
          record[column.name] = e.currentTarget.value;
          break;
      }
      changeListData(data);
      if (newData == null) {
        changeListCreatedData(record);
      }
    }
  };

  private onChangeDateData = async (e: CalendarChangeParams, record: any, column: ListColumnField) => {
    if (this.props.historyMode) return;
    const {
      list: { data, newData },
      changeListData,
      changeListCreatedData,
    } = this.props;
    const value: any = e.value instanceof Date ? e.value.valueOf() : typeof e.value == 'string' ? new Date(e.value).valueOf() : e.value;
    if (record && record.id != undefined && column.key) return;
    if (record != undefined) {
      record[column.name] = value;
      changeListData(data);
      if (newData == null) {
        changeListCreatedData(record);
      }
    }
  };

  private onChangeBooleanData = async (checked: boolean, record: Record<string, any>, column: ListColumnField) => {
    if (this.props.historyMode) return;
    const {
      list: { data, newData },
      changeListData,
      changeListCreatedData,
    } = this.props;
    record[column.name] = checked;
    changeListData(data);
    if (newData == null) {
      changeListCreatedData(record);
    }
    setTimeout(() => {
      this.onBlurData(record, column);
    }, 0);
  };

  private onBlurData = async (record: Record<string, any>, column: ListColumnField) => {
    if (this.props.historyMode) return;
    const {
      list: { list, newData, isUpdate },
      changeListCreatedData,
    } = this.props;
    if (record && record.id != undefined && column.key) return;
    if (!isUpdate) return;
    if (newData == null) return;
    const keyField = list.fields.find((column: ListColumnField) => column.key);
    if (keyField == undefined) return;
    const key = record[keyField.name];
    record['lastUpdated'] = new Date().valueOf();
    if (key == undefined || key.trim().length == 0) {
      MessageUtil.showError('Key field is empty ' + keyField.name);
      return;
    }
    try {
      this.setState({ loading: true });
      await this.listDataService.addData(list.name, keyField.name, newData);
      changeListCreatedData(null);
      this.setState({ loading: false });
    } catch (e) {}
  };

  private onPageChange = (event: CustomPaginatorProps) => {
    if (this.props.historyMode) {
      this.setState({ rows: event.rows, currentPage: event.page });
      return;
    }
    this.setState({ rows: event.rows, currentPage: event.page }, this.resubscribeTracker);
  };

  private async prepareCount() {
    const { currentPage, filter, rows, totalRecord } = this.state;
    const {
      list: { list },
    } = this.props;
    const dataCollection: string = `list_${list.name}`;
    const query = QueryBuilder.select().from(dataCollection).where(filter).build();
    const count = await this.listDataService.getCount(list.name, query);
    this.setState({ totalRecord: count });
    if (count != 0 && totalRecord > count && count % rows == 0 && currentPage != 1) {
      this.setState({ currentPage: currentPage - 1 }, () => this.resubscribeTracker());
    }
  }

  private removeCacheData = async (record: Record<string, any>) => {
    const {
      list: { list },
    } = this.props;
    if (record.id == undefined) return;
    await this.listDataService.deleteListData(list.name, record.id);
  };

  private prepareFilterFields = async () => {
    const {
      list: { list },
    } = this.props;
    await FilterUtil.getListDataFields(list.fields, true);
  };

  private onChangeFilter = (filter: Filter) => {
    const isSame = _.isEqual(filter, this.state.filter);
    if (isSame) return;
    this.setState({ filter }, this.resubscribeTracker);
  };

  private onExport = async () => {
    const {
      list: { list },
    } = this.props;
    try {
      const job: ListDataExportJob = {
        timestamp: Date.now(),
        status: 'PENDING',
        extension: 'csv',
        path: '',
        type: 'LIST_DATA_EXPORT',
        list: list.name,
        ids: [],
      };
      await this.jobService.schedule(job);
      MessageUtil.success({
        summary: 'Success',
        detail: 'Export job has been scheduled',
      });
    } catch (e) {
      console.error(e);
    }
  };

  private uploadFile = async () => {
    const {
      list: { list },
    } = this.props;
    const { file } = this.state;
    if (file == undefined) return;
    const endpoint = `${apiUrl}/list-data/upload`;
    const formData = new FormData();
    formData.append('file', file);
    formData.append('list', list.name);
    try {
      await this.httpClient.execute(HttpMethod.POST, endpoint, formData, undefined, undefined, (progressEvent: ProgressEvent) => {
        const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
        if (percentCompleted == 100) {
          MessageUtil.success({
            summary: 'Success',
            detail: 'File has been uploaded',
          });
          this.setState({ percent: percentCompleted, progress: 'uploaded' });
        } else {
          this.setState({ percent: percentCompleted, progress: 'uploading' });
        }
      });
    } catch (e) {
      console.error(e);
    }
  };

  private onRemoveAll = async () => {
    const {
      component: { selectedComponentIds },
      list: { list },
    } = this.props;
    const ids: string[] = (selectedComponentIds as any[]).map((id) => id?.id).filter((i) => i != undefined);
    await this.listDataService.removeAll(list.name, ids);
  };
}

class State {
  currentPage: number = 1;
  rows = 10;
  totalRecord = 0;
  loading: boolean = true;
  fileVisible: boolean = false;
  filter: Filter = empty();

  percent: number = 0;
  progress: UploadProgress = 'idle';
  file: File | null = null;
  pendingDelete: boolean = false;
}

interface Props extends ReduxProps {
  historyMode?: boolean;
  historyMeta?: ListHistoryMeta;
}

const mapStateToProps = (state: RootState) => ({
  list: state.list as ListState,
  component: state.component as ComponentState,
});
const mapDispatchToProps = { changeList, changeListIsUpdate, changeListData, changeListCreatedData };
const connector = connect(mapStateToProps, mapDispatchToProps);
type ReduxProps = ConnectedProps<typeof connector>;

export default connector(ListDataViewComponent);
